import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IAlert,
  IAlertListRequest,
  IAlertCreateRequest,
  IAlertUpdateRequest,
  AlertState,
} from "@/types/alert";
import CustomRequest from "../customRequest";

const actions: ActionTree<AlertState, RootState> = {
  async salesGetList({ commit }, params: IAlertListRequest) {
    await CustomRequest.get<IPagination<IAlert>>({
      uri: "/sales/alert",
      params,
      commit,
      target: "pagination",
    });
  },

  async salesGet({ commit }, alertId: number) {
    await CustomRequest.get<IAlert>({
      uri: `/sales/alert/${alertId}`,
      commit,
      target: "single",
    });
  },

  // async salesUpdate(
  //   { commit },
  //   datas: { alert_id: number; params: IAlertUpdateRequest }
  // ) {
  //   const { error } = await CustomRequest.patch<IAlert>({
  //     uri: `/sales/alert/${datas.alert_id}`,
  //     params: datas.params,
  //     commit,
  //     target: "single",
  //     flash: true,
  //   });

  //   return !error;
  // },

  // async salesCreate({ commit }, params: IAlertCreateRequest) {
  //   const { error } = await CustomRequest.post<IAlert>({
  //     uri: `/sales/alert/`,
  //     params,
  //     commit,
  //     target: "single",
  //     flash: true,
  //   });

  //   return !error;
  // },

  // async salesDelete({ commit }, alert_id: number) {
  //   const { error } = await CustomRequest.delete({
  //     uri: `/sales/alert/${alert_id}`,
  //     flash: true,
  //   });

  //   return !error;
  // },
};

export default actions;
